import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from 'react-oidc-context'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { App } from '@/App'
import { ApiTokenBridge } from '@/auth/ApiTokenBridge'
import { RequireAuth } from '@/auth/RequireAuth'
import { oidcConfig } from '@/auth/oidcConfig'
import { ApiError } from '@/api/client'
import { AppErrorBoundary } from '@/components/AppErrorBoundary'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Bei 401 und 403 hilft kein erneuter Versuch, das ist ein
        // Berechtigungsproblem. Nur echte Ausfaelle wiederholen.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false
        }
        return failureCount < 2
      },
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Das Element #root fehlt in index.html.')
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <AuthProvider {...oidcConfig}>
          <RequireAuth>
            <ApiTokenBridge>
              <QueryClientProvider client={queryClient}>
                <App />
              </QueryClientProvider>
            </ApiTokenBridge>
          </RequireAuth>
        </AuthProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  </StrictMode>,
)
